import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import { getCSSColorBg } from '~/utilities/getCSS';
import LogoWrapper from '~/components/Layout/Footer/LogoWrapper';
import LogoSeparator from '~/components/Layout/Footer/LogoSeparator';
import Notice from '~/components/Layout/Footer/Notice';
import Nav from '~/components/Layout/Footer/Nav';

const footerClasses = cva('w-full px-4 pt-6', {
  variants: {
    color: getCSSColorBg(),
  },
});

export default component$((): JSX.Element => {
  const appData = useContext(AppDataContext);

  return (
    <footer
      data-testid='footer'
      class={footerClasses({
        color: appData.themeComponents.footer.backgroundColor.value,
      })}
    >
      <div class='max-w-[1440px] mx-auto'>
        <LogoWrapper />
        <Nav />
        <LogoSeparator />
        <Notice />
      </div>
    </footer>
  );
});
